import { addHttpsProtocol } from 'root/src/shared/util/protocolUtil';
export function isMultiGameDrop(dropEvent) {
    return Boolean(dropEvent.isMultiGame);
}
export function isSingleGameDrop(dropEvent) {
    return !dropEvent.isMultiGame;
}
export function getDropEventDropName(dropEvent) {
    if (isMultiGameDrop(dropEvent)) {
        return dropEvent.campaignProduct || dropEvent.campaignName;
    }
    if (isSingleGameDrop(dropEvent)) {
        return dropEvent.dropTitle || dropEvent.campaignName;
    }
    return dropEvent.campaignName;
}
export function getDropEventGameName(dropEvent) {
    if (isMultiGameDrop(dropEvent)) {
        return dropEvent.campaignProduct;
    }
    if (isSingleGameDrop(dropEvent)) {
        return dropEvent.gameObj.label;
    }
    return dropEvent.campaignName;
}
export function getDropEventImage(dropEvent) {
    var _a, _b;
    if (isMultiGameDrop(dropEvent) && ((_a = dropEvent.campaignThumbnail) === null || _a === void 0 ? void 0 : _a.url)) {
        return addHttpsProtocol(dropEvent.campaignThumbnail.url);
    }
    if (isSingleGameDrop(dropEvent) && ((_b = dropEvent.gameObj) === null || _b === void 0 ? void 0 : _b.image)) {
        return addHttpsProtocol(dropEvent.gameObj.image);
    }
    return null;
}
